export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20cinematic%20light%20streaks%20in%20deep%20coral%20and%20amber%20tones%2C%20soft%20geometric%20patterns%2C%20modern%20entertainment%20atmosphere%2C%20dark%20elegant%20corners%2C%20smooth%20color%20transitions%2C%20high%20end%20visual%20design%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=hero-bg-99video&orientation=landscape"
          alt="99视频背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm font-medium text-primary-300">聚合热门视频平台</span>
              <span className="w-1 h-1 rounded-full bg-primary-400"></span>
              <span className="text-sm text-primary-300/80">每日更新</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-heading leading-tight mb-4">
              99视频&nbsp;&mdash;&nbsp;聚合热门视频平台，高清免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              香蕉视频 · 红桃视频 · 91视频 · 蜜桃视频，一站畅享
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed mb-8 max-w-xl lg:max-w-none">
              99视频汇聚香蕉视频、红桃视频、91视频、蜜桃视频等热门视频平台资源，致力于为广大影迷提供海量高清影视内容的免费在线观看服务。平台每日同步各大平台最新电影、热门电视剧、综艺节目与动漫番剧，无需注册登录，打开即看，不缓冲流畅播放。无论是最新上映的大片、经典回顾还是热门连载，99视频都能满足您的观影需求。这里聚合了全网最热门的视频资源，是您追剧看片的首选入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl bg-primary-500/25 flex items-center justify-center">
                  <i className="ri-movie-line text-primary-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm whitespace-nowrap">10万+</p>
                  <p className="text-white/55 text-xs">影视资源收录</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl bg-accent-500/25 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm whitespace-nowrap">极速加载</p>
                  <p className="text-white/55 text-xs">不缓冲流畅播</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl bg-secondary-500/25 flex items-center justify-center">
                  <i className="ri-refresh-line text-secondary-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm whitespace-nowrap">每日更新</p>
                  <p className="text-white/55 text-xs">同步最新内容</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-xl text-sm transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观看
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-xl text-sm backdrop-blur-sm border border-white/15 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                了解平台特色
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-accent-500/15 to-primary-500/20 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-black/40 backdrop-blur-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20of%20floating%20video%20screens%20and%20film%20reels%20in%20warm%20coral%20and%20golden%20amber%20light%2C%20modern%20digital%20entertainment%20concept%2C%20glowing%20play%20buttons%2C%20smooth%20dark%20background%20with%20gradient%20highlights%2C%20futuristic%20yet%20warm%20atmosphere%2C%203D%20render%20style%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=hero-visual-99video&orientation=landscape"
                  alt="99视频 - 聚合热门视频平台主视觉"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              </div>
              <div className="absolute -bottom-3 -right-3 w-24 h-24 rounded-2xl bg-primary-500/15 border border-primary-400/20 backdrop-blur-md flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-play-circle-fill text-primary-400 text-2xl"></i>
                  <p className="text-white text-xs font-medium mt-1">高清</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}